import { css, styled } from 'styled-components';

export const Container = styled.div<{ $disabled?: boolean }>`
  transition: all 220ms cubic-bezier(0.175, 0.885, 0.32, 1.1);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.$disabled
      ? css`
          cursor: not-allowed;
          opacity: 0.4;
        `
      : css`
          &:hover {
          }
        `}
`;

export const OffsetContainer = styled.div`
  display: flex;
  gap: 4px;
  position: relative;
  transition: inherit;
  align-items: center;
  /* svg {
    position: absolute;
    display: block;
    top: -2px;
    margin: 0;
    margin-left: 4px;
  } */
`;
